import { useMemo } from 'react';

import { useGetOptionsForCLA } from 'hooks/useGetOptionsForCLA';
import { useTranslation } from 'react-i18next';

import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';
import { dateFormatter, nestedFieldValueGetter } from 'utils/grid';

import { GridColDef } from '@mui/x-data-grid-pro';

export const useGetColumnDefs = (): GridColDef[] => {
  const { t } = useTranslation('common');

  const options = useGetOptionsForCLA();

  return useMemo(
    () => [
      {
        field: 'dutyTypeDyn',
        headerName: t('DHTClaSettings.grid.dutyTypeDynId'),
        type: 'string',
        hideable: false,
        sortable: true,
        valueGetter: (params) => {
          const { row } = params;
          const { dutyTypeDyn } = row;
          const { code, description } = dutyTypeDyn;
          return `${code} - ${description}`;
        },
        minWidth: 200,
        flex: 1
      },
      {
        field: 'claId',
        type: 'singleSelect',
        headerName: t('DHTClaSettings.grid.claId'),
        valueOptions: options,
        valueFormatter: (params) => singleSelectValueFormatter(params, options),
        minWidth: 100,
        flex: 1
      },
      {
        field: 'dutyTypeDyn.dccSvc',
        type: 'string',
        headerName: t('DHTClaSettings.grid.dccSvc'),
        valueGetter: nestedFieldValueGetter,
        minWidth: 50,
        flex: 1
      },
      {
        field: 'hcYhsLc',
        type: 'string',
        headerName: t('DHTClaSettings.grid.hcYhsLc'),
        minWidth: 100,
        flex: 1
      },
      {
        field: 'hcYhsLcSec',
        type: 'string',
        headerName: t('DHTClaSettings.grid.hcYhsLcSec'),
        minWidth: 100,
        flex: 1
      },
      {
        field: 'hcPayLc',
        type: 'string',
        headerName: t('DHTClaSettings.grid.hcPayLc'),
        minWidth: 100,
        flex: 1
      },
      {
        field: 'hcPayLcSec',
        type: 'string',
        headerName: t('DHTClaSettings.grid.hcPayLcSec'),
        minWidth: 100,
        flex: 1
      },
      {
        field: 'zhcYhsLc',
        type: 'string',
        headerName: t('DHTClaSettings.grid.zhcYhsLc'),
        minWidth: 100,
        flex: 1
      },
      {
        field: 'zhcYhsLcSec',
        type: 'string',
        headerName: t('DHTClaSettings.grid.zhcYhsLcSec'),
        minWidth: 100,
        flex: 1
      },
      {
        field: 'zhcPayLc',
        type: 'string',
        headerName: t('DHTClaSettings.grid.zhcPayLc'),
        minWidth: 100,
        flex: 1
      },
      {
        field: 'zhcPayLcSec',
        type: 'string',
        headerName: t('DHTClaSettings.grid.zhcPayLcSec'),
        minWidth: 100,
        flex: 1
      },
      {
        field: 'dutyTypeDyn.valid.from',
        headerName: t('validFrom'),
        type: 'date',
        valueGetter: nestedFieldValueGetter,
        valueFormatter: dateFormatter,
        minWidth: 100,
        flex: 1
      },
      {
        field: 'dutyTypeDyn.valid.to',
        headerName: t('validTo'),
        type: 'date',
        valueGetter: nestedFieldValueGetter,
        valueFormatter: dateFormatter,
        minWidth: 100,
        flex: 1
      }
    ],
    [t, options]
  );
};
